import { render, staticRenderFns } from "./ricercaGaranzie_webins.vue?vue&type=template&id=02cb6e30&"
import script from "./ricercaGaranzie_webins.vue.ts?vue&type=script&lang=ts&"
export * from "./ricercaGaranzie_webins.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports